import { createBrowserHistory } from 'history';
import { urlCheck } from 'services/utils';

export const history = createBrowserHistory();
export const host = urlCheck(`${process.env.REACT_APP_API_URL}`);
export const BACKEND_REFRESH_TOKEN_GRANT_TYPE = 'refresh_token';
